import * as Yup from "yup";


export const TestSchema = Yup.object({
    test: Yup.string().required(" Enter Test Name"),
    url: Yup.string().required(" Enter Api URL"),
    status: Yup.string().required(" Select Status"),
});